<template lang="pug">  
  v-row(no-gutters)
    v-col(cols=12)
      v-row.mx-1(
        no-gutters
        cols=12
        md=6
      )
        v-col.px-1.mb-1(
          cols=12
          md=3
        ).pt-3
          n-select-game-type(
            v-model='gameTypeSelect'
            :group-type-id="2"
            @change='gameSelect'
          )
        v-col.px-1.mb-1(
          cols=12
          md=3
        ).pt-3
          selectGameStatusScope(
            v-model='status'
            @input='statusSelect'
          )
        v-col.px-1(cols='12', md='3').pt-3
          n-datepicker-range(:date-range='dateRange', :max-days="15", @setDateRange='setDateRange')
    v-col(cols=12) 
      n-data-table-card-result.mt-3(
        :headers='headers'
        :items='items'
        :meta='meta' 
        @nextpage='nextpage'
      )
        template(#item.win_amount='{ item }')
          b(:class="classColor(item)") {{ item.win_amount | currency }} 

        template(#item.centerActionEffectToCard='{ item }') 
          v-icon(
            v-if='item.game_type && item.room' 
            @click='viewLotto(item)'
          ) mdi-eye

        template(#item.game_type='{ item }')
          | {{ item.room ? (item.room || {}).name : (item.game_type || {}).name }}

        template(#item.stake_status.name='{ item }') 
          v-chip.pa-2.text-center(
            dark
            outlined
            :color='colorStake (item)'
          ) 
            template(v-if="item.stake_status.name == 'ถูกรางวัล'")
              | ชนะ
            template(v-else-if="item.stake_status.name == 'แทงไม่ถูก'")
              | แพ้
            template(v-else)
              | {{ item.stake_status.name  }}

        template(#item.rightActionEffectToCard='{item}')
          | {{ item.created_at | dateFormat}}
        template(#item.leftActionEffectToCard='{ item }') 
          v-btn(
            v-if='canReturnList (item)'
            rounded
            outlined
            color='green'
            @click='removeLotto(item)'
          )
            v-icon(small) mdi-close
            | {{ $t('button.return-lotto-list') }} 
    loading-status(:had-data='hadData')

</template> 
<script>  
import { dateConvert, dateFormat, getPastDate } from '@/plugins/time'
import selectGameStatusScope from './SelectGameStatusScope'
import { st as apiSt } from '@/apis'

export default {
  components: {
    selectGameStatusScope
  },
  data: () => ({
    dateRange : ['',''],
    gameTypeSelect : {
      game_type_name : '',
      game_type_id : '',
      game_id : '',
      game_name : '' 
    },
    status: null,
    hadData : false,
    items: [],
    page:1, 
    meta : {},
    headers:[  
      { text: 'table.view-lotto-list', value: 'centerActionEffectToCard'},
      { text: 'table.ref-id', value: 'ref_id' },
      { text: 'table.type', value: 'game_type' },
      { text: 'table.date-time', value: 'rightActionEffectToCard'},
      { text: 'table.bet-amount', value: 'bet_amount', format:'currency' },
      { text: 'table.win-amount', value: 'win_amount' },
      { text: 'table.description', value: 'description' },
      { text: 'table.status', value: 'stake_status.name' },
      { text: 'table.return-lotto-list', value: 'leftActionEffectToCard' },
    ]
  }),

  async created () {
    const pastDate = this.getPastDate(10)
    this.dateRange[0] = pastDate
  },

  methods: {   
    dateFormat,
    dateConvert,
    getPastDate,
    canReturnList (item) {
      return item.stake_status.id === 2 && (dateConvert(item.room.locked_at)>new Date())
    },
    colorStake (item) { 
      return item.stake_status.id===3 ? 'success':item.stake_status.id===2 ? 'blue' : 'red'
    },
    classColor (item) {
      return item.stake_status.id===3 ? 'green--text' : 'red--text'
    },
    gameSelect (game_type,game) {  
      this.$ga.event('Button', 'SelectGameType', 'StakeListPage','' )
      this.gameTypeSelect = {
        game_type_name : game_type.name,
        game_type_id : game_type.id,
        game_id : game.id,
        game_name : game.name,
      }
      this.page = 1
      this.load()
    },

    statusSelect () {
      this.page = 1
      this.load()
    },

    setDateRange (value) { 
      this.dateRange = value
      if(this.dateRange[1] !== ''){
        this.$ga.event('Button', 'SelectDateRange', 'StakeListPage','' )
        this.load ()
      } 
    },
    
    async load (params = {}) { 
      params = {
        page : this.page,
        game_type_id : this.gameTypeSelect.game_type_id,
        start_date : this.dateRange[0],
        end_date : this.dateRange[1],
        game_id : this.gameTypeSelect.game_id,
        group_game_type_id: 2, // game
        status: this.status
        // status: [1, 2]
        // is_only_internal : 0 
      }

      this.hadData = false
      const [err,data,,meta ] = await apiSt.getAllList(params) 
      this.hadData = true

      if(err){ 
        this.$alert('',err,'warning')  
        return
      }

      this.items = data  
      this.meta = meta 
    },

    viewLotto (item) {
      this.$ga.event('Button', 'ViewStakeListInfo', 'StakeListPage','')
      this.$emit('addDialog', item)
    },

    removeLotto (item) { 
      this.$ga.event('Button', 'RemoveStakeList', 'StakeListPage','')
      if(dateConvert(item.room.locked_at)>new Date()) {
        this.$emit('remove', item.list_uuid) 
      }
    },

    nextpage (value) {
        this.page = value
        this.load ()
    }
  }
};
</script>